import { combineReducers } from '@reduxjs/toolkit';
import orderDataReducers from './orders/combinedReducers';
import lookupDataReducer from './lookup_status/lookupDataReducer';
import statusDataReducer from './lookup_status/statusDataReducer';
import isaDataReducer from './isa/isaDataReducer';
import { deliveryReducers } from './deliveries/combinedReducers';
import { invoicesDataReducers } from './invoices/CombinedReducers';
import { productsReducers } from './products/ProductReducers';
import { libraryDocumentsReducers } from './library/LibraryDocumentsReducers';

const dataActionsReducer = combineReducers({
    lookups: lookupDataReducer,
    statusses: statusDataReducer,
    isa: isaDataReducer,
    orders: orderDataReducers,
    deliveries: deliveryReducers,
    invoices: invoicesDataReducers,
    products: productsReducers,
    libraryDocuments: libraryDocumentsReducers
});

export default dataActionsReducer;